import { render, staticRenderFns } from "./ModalRenombrarDocumento.vue?vue&type=template&id=77c6fd8d&scoped=true"
import script from "./ModalRenombrarDocumento.vue?vue&type=script&lang=js"
export * from "./ModalRenombrarDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c6fd8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c6fd8d')) {
      api.createRecord('77c6fd8d', component.options)
    } else {
      api.reload('77c6fd8d', component.options)
    }
    module.hot.accept("./ModalRenombrarDocumento.vue?vue&type=template&id=77c6fd8d&scoped=true", function () {
      api.rerender('77c6fd8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/repositorio/ModalRenombrarDocumento.vue"
export default component.exports